/* AND — subscription popup */
(function () {
  'use strict';
  var pop = document.getElementById('AndPopup');
  if (!pop) return;
  var KEY = 'and_popup';
  var d = pop.dataset;
  var design = d.design === 'true';
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  };
  var state = store.get();
  var lastFocus = null;
  var shown = false;
  var timers = [];

  function step(name) {
    pop.querySelectorAll('[data-pop-step]').forEach(function (el) { el.hidden = el.getAttribute('data-pop-step') !== name; });
  }
  function open(which) {
    if (shown && !which) return;
    shown = true;
    step(which || 'form');
    lastFocus = document.activeElement;
    pop.hidden = false;
    pop.setAttribute('aria-hidden', 'false');
    void pop.offsetWidth; pop.classList.add('is-open');
    document.body.classList.add('has-drawer');
    var f = pop.querySelector(which === 'done' ? '.and-pop__shop' : 'input[type=email]');
    setTimeout(function () { if (f && window.matchMedia('(min-width: 750px)').matches) f.focus(); }, 350);
    cleanup();
  }
  function close(remember) {
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-drawer');
    setTimeout(function () { pop.hidden = true; }, 350);
    if (remember && !design) { state.dismissedAt = Date.now(); store.set(state); }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-pop-close]')) { e.preventDefault(); close(true); }
    if (e.target.closest('[data-pop-close-link]')) { close(false); }
    var copy = e.target.closest('[data-pop-copy]');
    if (copy) {
      var code = copy.getAttribute('data-pop-copy');
      var done = function () { var s = copy.querySelector('[data-pop-copied]'); if (s) s.textContent = 'Copied!'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
    if (e.target.closest('[data-pop-wa]')) { state.subscribed = true; store.set(state); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true);
    if (e.key === 'Tab' && pop.classList.contains('is-open')) {
      var f = Array.prototype.filter.call(pop.querySelectorAll('a[href],button,input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  var form = pop.querySelector('[data-pop-form]');
  if (form) form.addEventListener('submit', function () { state.pending = Date.now(); store.set(state); });

  /* Returning from a successful signup */
  if (/[?&]customer_posted=true/.test(location.search) && state.pending && Date.now() - state.pending < 10 * 60 * 1000) {
    delete state.pending; state.subscribed = true; store.set(state);
    open('done');
    if (history.replaceState) {
      var u = new URL(location.href); u.searchParams.delete('customer_posted');
      history.replaceState({}, '', u.pathname + u.search + u.hash.replace('#AndPopupForm', ''));
    }
    return;
  }
  /* Signup failed (error shown inside the form): reopen so the visitor sees it */
  if (pop.querySelector('.and-pop__error')) { open('form'); return; }

  /* Theme editor: open while the section is selected */
  document.addEventListener('shopify:section:select', function (e) { if (e.detail.sectionId === d.section) open('form'); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.detail.sectionId === d.section) close(false); });
  if (design) return;

  /* Rules */
  if (state.subscribed) return;
  var days = parseInt(d.days, 10) || 7;
  if (state.dismissedAt && Date.now() - state.dismissedAt < days * 864e5) return;
  if (d.skipCart === 'true' && parseInt(d.cartCount, 10) > 0) return;

  function cleanup() { timers.forEach(clearTimeout); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onExit); }
  function cartHasItems() { var c = document.querySelector('.cart-count'); return d.skipCart === 'true' && c && parseInt(c.getAttribute('data-count') || c.textContent, 10) > 0; }
  function tryOpen() { if (!shown && !cartHasItems() && !document.body.classList.contains('has-drawer')) open('form'); }

  var delay = parseInt(d.delay, 10);
  if (delay >= 0) timers.push(setTimeout(tryOpen, Math.max(delay, 0) * 1000));
  var pct = parseInt(d.scroll, 10);
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && (scrollY / h) * 100 >= pct) tryOpen();
  }
  if (pct > 0) window.addEventListener('scroll', onScroll, { passive: true });
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) tryOpen(); }
  if (d.exit === 'true' && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) document.addEventListener('mouseout', onExit);
})();
